/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AsinPoolStatsDTO interface.
 */
export function instanceOfAsinPoolStatsDTO(value) {
    return true;
}
export function AsinPoolStatsDTOFromJSON(json) {
    return AsinPoolStatsDTOFromJSONTyped(json, false);
}
export function AsinPoolStatsDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'] == null ? undefined : json['code'],
        'flag': json['flag'] == null ? undefined : json['flag'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}
export function AsinPoolStatsDTOToJSON(json) {
    return AsinPoolStatsDTOToJSONTyped(json, false);
}
export function AsinPoolStatsDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'flag': value['flag'],
        'count': value['count'],
    };
}
